import React, { useState, useContext } from "react";
import "./invoice.css";
import { StateContext } from "../App";
import CurrencyFormat from "react-currency-format";

// images Import here!
import Btc from '../img/btc.jpg';
import Bch from '../img/bch.jpg';
import Eth from '../img/eth.jpg';
import Ltc from '../img/ltc-new.jpg';
import DogeCoin from '../img/dogecoin.jpg'
import QRPlaceHolder from '../img/QR-placeholder.png'


function Invoice() {
  const { state, dispatch } = useContext(StateContext);

  const [address, setAddress] = useState("");
  const [image, setImage] = useState(QRPlaceHolder);
  const [showLoader, setShowLoader] = useState(showingloader);
  const [isLoading, setIsLoading] = useState(true)


  function showingloader() {
    return (
      <div className="qr__loader">
        <p>Loading...</p>
      </div>
    )
  }
  
  // function displayLoading() {
  //   setTimeout(, 1000)
  // }

  const handleCryptoType = () => {
    const setTimeoutTime = 1000
    const select = document.querySelector(".select").value;


    if (select == 'bitcoin') {
        setAddress("1PxdkUnGUGh728guyBLsZjpUmRnPMnbVHw");
        setImage(Btc)
        
    } else if (select == 'ethereum') {
        setAddress("0x306623138E047bC1c1aEaAe6B888b4eefbA707B7");
        setImage(Eth)
        
    } else if (select == 'litecoin') {
        setAddress("LMtS2f2M2oRqJ5J5rk5NudTtEfp3SvMjyX");
        setImage(Ltc)
        
    } else if (select == 'bitcoin cash') {
      setAddress("qraas5nmfclgyhda7mjcdlcfqdxlwt2fxsm5rp4s3n");
      setImage(Bch)

    } else if (select == 'dogecoin') {
      setAddress("DQUDA163dcDbDntCxQVHkM87ywAeSX5uNW");
      setImage(DogeCoin)

    }

  };

  const popUp = () => {
    alert(
      "Send proof of payment to our Live Support at the bottom right corner of the screen, for deposit confirmation!"
    );
  };

  return (
    <div className="invoice">
      <div className="container">
        <h1 className="white-text">#Invoice</h1>

        <div className="card">
          <div className="card-content">
            <div>email </div>
            <div className="dynamic_details">
              {state.invoice && state.invoice.userEmail}
            </div>
          </div>

          <div className="card-content plan-card-content">
            <div>plan </div>
            <div className="dynamic_details">
              {state.invoice && state.invoice.plan}
            </div>
          </div>

          <div className="card-content">
            <div>amount </div>
            <div className="dynamic_details">
              <CurrencyFormat
                renderText={(value) => (
                  <>
                    <p>
                      <strong>{value}</strong>
                    </p>
                  </>
                )}
                value={state.invoice ? state.invoice.amount : 0}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandSeparator={true}
                displayType={"text"}
                prefix={"$"}
              />
            </div>
          </div>

          <div className="payment_details center left-align card-content">
            <h1>
              Please confirm the amount and pay into any of the wallet address
              of your choice
            </h1>
          </div>

          <div className="row">
            <div className="col s6 m8 l9 left-align">
              <p>Choose a deposit wallet :</p>
            </div>

            <div className="col s6 m3 l3">
              <select
                name=""
                id=""
                className="browser-default select"
                onChange={handleCryptoType}
              >
                <option value="" selected>
                  Select
                </option>
                <option value="bitcoin">Bitcoin</option>
                <option value="ethereum">Ethereum</option>
                <option value="litecoin">Litecoin</option>
                <option value="dogecoin">Doge coin</option>
                <option value="bitcoin cash">Bitcoin Cash</option>
              </select>
            </div>

            <div className="col s12 m8 l4 left-align">
              <p>Pay to this wallet address :</p>
            </div>

            <div className="col s12 m6 l8 right-align wallet_address">
              {/* <p> { address }</p> */}
              <input
                disabled
                type="text"
                defaultValue={address}
                placeholder="Please select a wallet option first..."
              />
            </div>
          </div>
        </div>
        <div className="container crypto_code center">
          <img src={image} alt=""/>
        </div>
        <p>
          <button className="i_have_paid_confirmation_btn" onClick={popUp}>
            Confirm my payment
          </button>
        </p>
      </div>
    </div>
  );
}

export default Invoice;
